import { React, PropTypes } from '../../dependencies';

import Divider from '../Divider';
import Summary from '../../containers/Summary';
import Items from '../Items';
import Attachments from '../../containers/Attachments';
import Note from '../Note';

function Body({ expense: { id, items, currency, hasAttachment, note } }) {
    return (
        <>
            <Items {...{ items, currency }} />

            <Summary expenseId={id} />

            {hasAttachment && <Divider />}

            <Attachments expenseId={id} />

            {note && (
                <>
                    <Divider />
                    <Note value={note} />
                </>
            )}
        </>
    );
}

Body.propTypes = {
    expense: PropTypes.shape({
        id: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(Items.itemShape.isRequired).isRequired,
        currency: PropTypes.string.isRequired,
        hasAttachment: PropTypes.bool.isRequired,
        note: PropTypes.string.isRequired,
    }).isRequired,
};

export default Body;
